"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var getAuthToken = exports.getAuthToken = function getAuthToken(state, props) {
  return state.dao.authToken;
};
var getRefreshToken = exports.getRefreshToken = function getRefreshToken(state, props) {
  return state.dao.refreshToken;
};
var isRefreshingAuthToken = exports.isRefreshingAuthToken = function isRefreshingAuthToken(state, props) {
  return state.dao.isRefreshingAuthToken;
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/ml-fetch/dist/store/daoStore.js
 ** module id = 647
 ** module chunks = 0
 **/